// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Injectable } from '@angular/core';

export interface SimpleNotificationOptions {
  label?: string;
  text: string;
  duration?: string;
  icon?: string;
}
@Injectable()
export class SimpleNotificationService {
  container = document.createElement('sh-notifications');

  notify({ label, duration, icon, text }: SimpleNotificationOptions): void {
    if (!this.container.parentElement) {
      document.body.appendChild(this.container);
      this.container.setAttribute(
        'style',
        'position: fixed; top: initial; bottom: 1rem; left: 50%; transform: translate(-50%, 0%);'
      );
    }
    const n = document.createElement('sh-notification-item');

    n.setAttribute('visible', '');
    n.setAttribute('duration', duration || 'short');
    if (label) {
      n.setAttribute('label', label);
    }
    const h = `
    <div style="display: flex; flex-direction: row; gap: 1rem; align-items: center">
      ${icon ? `<sh-icon icon="${icon}"></sh-icon>` : ''}
      ${text}
    </div>
    `;

    n.innerHTML = h;
    this.container.appendChild(n);
    n.addEventListener('close', () => {
      window.setTimeout(() => this.container.removeChild(n), 1000);
    });
  }
}
